// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.
import { Maybe, type MaybeType } from 'monet';
import type { FlagState } from '@atlassian/jira-servicedesk-automation-common/src/state/flags/types';
import type {
	SummaryPage,
	SummaryRunAsUserSettings,
	SummaryResult,
	SummaryEntities,
} from '../../model';
import type { State } from '../types';
import type { UIState } from '../ui/types';

export const getPersisted = (state: State): SummaryPage => state.persisted;

export const maybeResult = (state: State): MaybeType<SummaryResult> =>
	Maybe.fromNull(getPersisted(state).result);

export const maybeProjectRunAsUserSettings = (state: State): MaybeType<SummaryRunAsUserSettings> =>
	// @ts-expect-error - TS7006 - Parameter 'persisted' implicitly has an 'any' type.
	maybeResult(state).map((persisted) => persisted.projectRunAsUserSettings);

export const getUI = (state: State): UIState => state.ui;

export const getFlags = (state: State): FlagState => state.flags;

export const maybeEntities = (state: State): MaybeType<SummaryEntities> =>
	Maybe.fromNull(getPersisted(state).entities);
